import { render, staticRenderFns } from "./BillsDepartmen.vue?vue&type=template&id=a3256b3c&"
import script from "./BillsDepartmen.vue?vue&type=script&lang=js&"
export * from "./BillsDepartmen.vue?vue&type=script&lang=js&"
import style0 from "./BillsDepartmen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports